import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const store = new Vuex.Store({
    state: {
        userLogin : false,
        userAccount:'',
        code: null,
    },
    mutations: {
        updateUserState(state) {
            state.userLogin = true;
        },
        setCode(state, code) {
            state.code = code;
        }
    },
    getters: {
        getCode : (state) => {
            return state.code;
        }
    }
})

export default store;